<template>
	<div>
		<div class="xs-12 fs5 fw7 mt6 mb2">Policyholder</div>
		<case-form :schema="schema" />
		<!-- Contact Person -->
		<div class="xs-12 fs5 fw7 mt6 mb2">Contact Person</div>
		<case-form :schema="schemaContactPerson" />
	</div>
</template>

<script>
import CaseForm from "../../CaseForm/CaseForm.vue"

export default {
	name: "MSProposalPolicyholder",
	components: { CaseForm },
	computed: {
		schema() {
			return [
				{
					label: "Select Policyholder",
					component: "entitySelect",
					bindTo: "case.holder",
					entity: "case.holder",
					props: {
						allowedEntityTypes: ["company"]
					}
				},
				{
					label: "Customer Name",
					component: "entityField",
					entity: "case.holder",
					fieldToUpdate: "name",
					props: {
						updateOptions: {
							component: "text"
						}
					}
				},
				{
					label: "Address",
					component: "entityAddress",
					entity: "case.holder",
					relation: "case.holder.addresses",
					bindTo: "case.facts.holderAddressId",
					props: {
						suggest: {
							typeIncludes: "main"
						},
						createOptions: {
							type: "main"
						}
					}
				},
				{
					label: "Territorial Limits",
					component: "text",
					bindTo: "case.facts.territorialLimits"
				},
				{
					label: "Underwriter Approval",
					component: "text",
					bindTo: "case.facts.underwriterApproval"
				}
			]
		},
		schemaContactPerson() {
			return [
				{
					label: "Name",
					component: "text",
					bindTo: "case.facts.contactPersonName"
				},
				{
					label: "Title",
					component: "select",
					bindTo: "case.facts.contactPersonTitle",
					props: {
						options: [
							{
								name: "Mr.",
								value: "Mr"
							},
							{
								name: "Mrs.",
								value: "Mrs"
							},
							{
								name: "Ms.",
								value: "Ms"
							},
							{
								name: "Miss",
								value: "Miss"
							},
							{
								name: "Dr.",
								value: "Dr"
							}
						]
					}
				},
				{
					label: "Email",
					component: "text",
					bindTo: "case.facts.contactPersonEmail"
				},
				{
					label: "Mobile",
					component: "text",
					bindTo: "case.facts.contactPersonMobile"
				},
				{
					label: "Tel",
					component: "text",
					bindTo: "case.facts.contactPersonTelephone"
				},
				{
					label: "Fax",
					component: "text",
					bindTo: "case.facts.contactPersonFax"
				}
			]
		}
	}
}
</script>
